import template from './checkbox.html';

export default angular.module('gm.wealth.common')
  .directive('gmwCheckbox', gmwCheckbox)
  .name;

function gmwCheckbox() {
  'ngInject';

  const directive = {
    link,
    require: 'ngModel',
    replace: true,
    restrict: 'E',
    scope: {},
    template,
    transclude: true,
  };
  return directive;

  function link(scope, _elem, _attrs, ngModel) {
    scope.model = ngModel;
    scope.toggle = toggle;

    ngModel.$isEmpty = value => !value;

    function toggle() {
      ngModel.$setViewValue(!ngModel.$viewValue);
    }
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/checkbox/checkbox.js